import React, { useState, useEffect, useContext, useRef } from "react";
import styled from "styled-components";
import Navbar from "../components/Navbar";
import ModuleSlider from "../components/moduleSlider";
import MultipleCellSliders from "../components/MultipleCellSliders";
import TableB from "../components/TableB";
import DisplaySettings from "../utils/globalSetting";
import ModuleSettings from "../utils/moduleSettings";
import ResultsCell from "../components/ResultsCell";
import LoadingPopup from "../components/LoadingPopup";
import Footer from "../components/Footer";
import {downloadExcell} from "../utils/downloadExcell";
import { useNavigate } from "react-router-dom";
import ShowImageSettings from "../utils/showImageSettings";
import { Helmet } from "react-helmet";
import { useDownloadCellStatsQuery } from "../store/apis/api";
import { useFetchModuleQuery } from "../store/apis/api";
import { useFetchColourmapsQuery } from "../store/apis/api";

export default function ResultsModule () {
    const navigate = useNavigate();
    const settings = useContext(DisplaySettings);
    const batchName = settings['showBatchName'];
    const moduleName = settings['showModuleName'];
    const [showCellName, setShowCellName] = useState("");
    const [doShowCell, setDoShowCell] = useState(false);

    const links = [
        { name: "Home", link: "/landing" , isActive: true},
        { name: "Upload new images", link: "/upload", isActive:false },
        { name: "View analysis", link: "/resultsHighLevel", isActive:false },
        { name: "View batch", link: "/resultsOneBatch", isActive:false },
        { name: "View module", link: "/resultsModule", isActive:false },
        { name: "About", link: "/about", isActive: false},
        { name: "Help", link: "/help", isActive: false}
        // { name: "Contact us", link: "/contactUs", isActive:false },
    ];


    const [tableData, setTableData] = useState([]);
    const [tableColours, setTableColours] = useState([]);
    const [textColours, setTextColours] = useState([]);
    const [moduleCar, setModuleCar] = useState([]);
    const [cellCar, setCellCar] = useState([]);
    const [srcOG, setSrcOG] = useState("");
    const [srcColourmap, setSrcColourmap] = useState("");
    const [rows, setRows] = useState(1);
    const [columns, setColumns] = useState(1);
    const [indexImage, setIndexImage] = useState(0);
    const [imageName, setImageName] = useState("");


    const { data:cellStats, isLoading: cellStatsLoading, isError: cellStatsError } = useDownloadCellStatsQuery({ batchName,moduleName });
    console.log(cellStats);

    const { data: modulesData, isLoading: modulesDataLoading, isError: modulesDataError } = useFetchModuleQuery({ batchName, moduleName });
    console.log(modulesData);

    const { data: colormapsData, isLoading: colormapsDataLoading, isError: colormapsDataError } = useFetchColourmapsQuery({ batchName, moduleName });
    console.log(colormapsData);
   

    useEffect(() => {
        if (window.__REACT_SNAP__) return;
        if (modulesDataError || colormapsDataError) {
            sessionStorage.removeItem('tokens');
            navigate('/');
        }
    }, [modulesDataError, colormapsDataError, navigate]);
    
    useEffect(() => {
        if (window.__REACT_SNAP__) return;
        if (modulesData && modulesData.colourmaps.length > 0) {
            let colourmaps = modulesData.colourmaps;
            setTableData(modulesData.module);
            setTableColours(modulesData.colours);
            setTextColours(modulesData.textColour);
            setSrcOG(modulesData.el);
            setSrcColourmap(colourmaps[0]?.image || "");
            setImageName(colourmaps[0]?.name || "");
            setModuleCar(colourmaps || []);  
        }
    }, [modulesData]);


    useEffect(() => {
        if (window.__REACT_SNAP__) return;
        if (colormapsData) {
            const r = colormapsData.rows;
            const c = colormapsData.columns;
            const colourmaps = colormapsData.colourmaps;
            const newData = [];

            if (r > 1 && c > 1) {
            for (let i = 0; i < r; i++) {
                newData.push(colourmaps.slice(i * c, (i + 1) * c));
            }
            } else {
            newData.push(colourmaps);
            }

            setCellCar(newData);
        }
    }, [colormapsData]);

    const handleDownloadModuleStats = () => {
        if (cellStats && cellStats.stats) {
            downloadExcell({
                newData: cellStats.stats,
                fileName: `${moduleName}_modules_statistics`,
            });
         } else {
            alert('Error: No module statistics available.');
        }
    };

    const updateImageSettings = (id) => {
        console.log("Here")
        console.log(id)
        setIndexImage(id);
        setSrcColourmap(moduleCar[id]['image']);
        setImageName(moduleCar[id]['name']);
    }

    const upDateSettings = ({value1, value2, value3}) => {
        setDoShowCell(value1);
        setShowCellName(value2);
    }

    return (
        <Container>
            <Helmet>
                <title> View Module | SolarAIDD</title>
                <meta name="description" content="Examine individual module defects detected through AI analysis of PV EL images."/>
                <meta name="robots" content="noindex, nofollow" />
                <link rel="canonical" href="https://solaraidd.csir.co.za/resultsModule" />
            </Helmet>     
            <Navbar links={links} isScrolled={true}/>

            {!modulesDataLoading && !doShowCell && (
                <div className="container">
                    <div className="title">
                        <h1> Analysis of the {moduleName} EL module </h1>
                        <div className="sub-title">
                            <h4> Let's put a magnifying glass on the module. Here is a detailed analysis of the solar panel. </h4>
                        </div>
                    </div>

                    <div className="module-info">
                        <div className="sub-title">
                            <h2> Colour maps of the defects </h2>                    
                        </div>
                        <div className="image-row">
                            <ShowImageSettings.Provider value={{indexImage, updateImageSettings}}> 
                                <TableB data={tableData} title={'Analysis of ' + moduleName} fileName={'Overview_of_module_' + moduleName} colours={tableColours} textColours={textColours} />
                            </ShowImageSettings.Provider>                     
                            <div className="img-container">
                                <div className="sub-heading">
                                    <h3> Defect map showing: </h3>
                                    <h3> {imageName} </h3>
                                </div>
                                <img src={`data:image/jpeg;base64,${srcColourmap}`} alt="Defect Map" />
                            </div> 
                            <div className="img-container">
                                <div className="sub-heading">
                                    <h3> Original </h3>
                                    <h3> electroluminiscence image</h3>
                                </div>
                                <img src={`data:image/jpeg;base64,${srcOG}`} alt="EL Image" />
                            </div>                      
                        </div>
                        <h3> Colour maps for each defect type </h3>
                        <ModuleSlider data={moduleCar} batchName={batchName} viewMore={false}/>
                    </div>

                  

                    <div className="cell-info" id='showPosition'>
                        <div className="sub-title"  >                    
                            <h2> Analysis of the cells form the {moduleName} EL module </h2>
                        </div>
                        <div className="sub-context">
                            <h3> Download the summary report of the cell statistics for the module for offline analysis. </h3>
                            <button onClick={handleDownloadModuleStats}> Download cell statistics </button>
                        </div>
                        <ModuleSettings.Provider value={{showCellName, doShowCell, upDateSettings}}>
                            <MultipleCellSliders data={cellCar}  /> 
                        </ModuleSettings.Provider>
                    </div> 

                    <Footer />
                </div>
            )}

            {doShowCell && (
                <ModuleSettings.Provider value={{ showCellName, doShowCell, upDateSettings }}>
                    <ResultsCell batchName={batchName} moduleName={moduleName} cellName={showCellName} />
                </ModuleSettings.Provider>
            )}

            {modulesDataLoading && (
                <div className="container">
                    <LoadingPopup />
                </div>
            )}
                
        </Container>
    );
}

const Container = styled.div`
background: white;
.container {
    position: absolute;
    top: 3rem;
    left: 0;
    width: 100vw;
    grid-template-rows: 15vh 85vh;
    color: black;
    background: white;
    .title {
        text-align: center;
        padding: 3rem;
        .sub-title {
            padding: 2rem;
        }
    }
    .module-info {
        background: #d2d9dd;
        padding: 2rem;
        text-align: center;
        .sub-title {
            text-align: center;
        }
        .image-row {
            display: flex;
            gap: 4rem;
            padding: 3rem 0rem;
            align-items: start;
            justify-content: center;      
            text-align: center;                
            .img-container {
                .sub-heading {
                    padding: 0.5rem;
                }
                width = 35vw;
                overflow: hidden;
                color: black;                
                img {
                    width: 20rem;
                    height: 100%;
                    z-index: 10;
                }
            }            
        }
    }
    .cell-info {
        padding: 3rem;
        .sub-title {
            text-align: center;
        }
        .sub-context {
            text-align: center; 
            gap: 1rem;
            button {
                padding: 1rem 1.5rem;
                background-color: #E55B41;
                border: none;
                cursor: pointer;
                color: white;
                border-radius: 0.2rem;
                font-weight: bolder;
                font-size: 1.05rem;
                align-items: center;
            }
        } 
    }
}
`;